import { setActiveOrganisation } from "../../firebase/firebase_setup";
import { Box, Dialog, DialogTitle, List, ListItem } from "@mui/material";

function ChangeOrganisationDialog({userData, open, handleClose}) {

  const handleListItemClick = async(organisation) => {
    await setActiveOrganisation(organisation.id, userData);
    window.location.reload();
  }
  
  const organisations = userData.organisations;
  const filteredOrganisations = organisations //organisations.filter((x) => {x.id !== props.userData.active_organisation_id})

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Change Organisation</DialogTitle>
      <List sx={{ pt: 0 }}>
        {filteredOrganisations.map(organisation => {
          return (
            <Box sx={{marginLeft: '10px'}}>
              <ListItem sx={{cursor: 'pointer'}} disableGutters key={organisation.id} onClick={() => {handleListItemClick(organisation)}}>
                {organisation.id}
              </ListItem>
            </Box>
          )
        })}
      </List>
    </Dialog>
  )
} 

export default ChangeOrganisationDialog;